/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AutomatedValueModel } from '../models/automated-value-model';
import { GuidId } from '../models/guid-id';

@Injectable({
  providedIn: 'root',
})
export class AutomatedValueModelsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAutomatedValueModels
   */
  static readonly GetAutomatedValueModelsPath = '/api/v1/AutomatedValueModels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAutomatedValueModels$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModels$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<AutomatedValueModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.GetAutomatedValueModelsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AutomatedValueModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAutomatedValueModels$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModels$Plain(params?: {
  },
  context?: HttpContext

): Observable<Array<AutomatedValueModel>> {

    return this.getAutomatedValueModels$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<AutomatedValueModel>>) => r.body as Array<AutomatedValueModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAutomatedValueModels()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModels$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<AutomatedValueModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.GetAutomatedValueModelsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AutomatedValueModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAutomatedValueModels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModels(params?: {
  },
  context?: HttpContext

): Observable<Array<AutomatedValueModel>> {

    return this.getAutomatedValueModels$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<AutomatedValueModel>>) => r.body as Array<AutomatedValueModel>)
    );
  }

  /**
   * Path part for operation addAutomatedValueModel
   */
  static readonly AddAutomatedValueModelPath = '/api/v1/AutomatedValueModels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAutomatedValueModel$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addAutomatedValueModel$Plain$Response(params?: {
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GuidId>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.AddAutomatedValueModelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GuidId>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAutomatedValueModel$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addAutomatedValueModel$Plain(params?: {
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<GuidId> {

    return this.addAutomatedValueModel$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<GuidId>) => r.body as GuidId)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAutomatedValueModel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addAutomatedValueModel$Response(params?: {
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GuidId>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.AddAutomatedValueModelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GuidId>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAutomatedValueModel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addAutomatedValueModel(params?: {
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<GuidId> {

    return this.addAutomatedValueModel$Response(params,context).pipe(
      map((r: StrictHttpResponse<GuidId>) => r.body as GuidId)
    );
  }

  /**
   * Path part for operation getAutomatedValueModelById
   */
  static readonly GetAutomatedValueModelByIdPath = '/api/v1/AutomatedValueModels/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAutomatedValueModelById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModelById$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AutomatedValueModel>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.GetAutomatedValueModelByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AutomatedValueModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAutomatedValueModelById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModelById$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<AutomatedValueModel> {

    return this.getAutomatedValueModelById$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<AutomatedValueModel>) => r.body as AutomatedValueModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAutomatedValueModelById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModelById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AutomatedValueModel>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.GetAutomatedValueModelByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AutomatedValueModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAutomatedValueModelById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAutomatedValueModelById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<AutomatedValueModel> {

    return this.getAutomatedValueModelById$Response(params,context).pipe(
      map((r: StrictHttpResponse<AutomatedValueModel>) => r.body as AutomatedValueModel)
    );
  }

  /**
   * Path part for operation updateAutomatedValueModel
   */
  static readonly UpdateAutomatedValueModelPath = '/api/v1/AutomatedValueModels/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutomatedValueModel$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAutomatedValueModel$Plain$Response(params: {
    id: string;
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AutomatedValueModel>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.UpdateAutomatedValueModelPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AutomatedValueModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAutomatedValueModel$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAutomatedValueModel$Plain(params: {
    id: string;
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<AutomatedValueModel> {

    return this.updateAutomatedValueModel$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<AutomatedValueModel>) => r.body as AutomatedValueModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutomatedValueModel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAutomatedValueModel$Response(params: {
    id: string;
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AutomatedValueModel>> {

    const rb = new RequestBuilder(this.rootUrl, AutomatedValueModelsService.UpdateAutomatedValueModelPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AutomatedValueModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAutomatedValueModel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAutomatedValueModel(params: {
    id: string;
    body?: AutomatedValueModel
  },
  context?: HttpContext

): Observable<AutomatedValueModel> {

    return this.updateAutomatedValueModel$Response(params,context).pipe(
      map((r: StrictHttpResponse<AutomatedValueModel>) => r.body as AutomatedValueModel)
    );
  }

}
